var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"simple_thumbnail",on:{"click":function($event){return _vm.gotoContentHome({
      contentType: _vm.content.type,
      contentId: _vm.content.id
    })}}},[(_vm.contentRecoverable)?_c('badge-free',{attrs:{"free":_vm.contentRecoverable}}):_vm._e(),_c('img',{attrs:{"src":_vm.contentThumbnail,"alt":_vm.contentDescription}}),(_vm.content.original)?_c('text-original'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }